// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g9kEM","left":"styles_left__1U0XS","desktopActions":"styles_desktopActions__3wMF7","title":"styles_title__3AgU0"};